import { Injectable } from '@angular/core';

import { combineLatest, Observable } from 'rxjs';
import { take, tap } from 'rxjs/operators';

import { User, UserFunctions, UserPreferences } from '@stylehaven/components';
import { UserStoreService } from '../user/user-store.service';

@Injectable({ providedIn: 'root' })
export class UserResolverService {
    constructor(private store: UserStoreService) {}

    resolve(): Observable<[User, UserPreferences, UserFunctions]> {
        return combineLatest([
            this.store.initUser(),
            this.store.initUserPreferences(),
            this.store.initFunctions()
        ]).pipe(
            take(1),
            tap(([user, preferences, functions]) => {
                this.store.setUser(user);
                this.store.setUserPreferences(preferences);
            })
        );
    }
}
